<script>
const paymentTypes = {
  0: 'Cash',
  4: 'Debit',
  2: 'Credit',
  1: 'Cheque',
  3: 'Gift Card',

  'Cash' : 0,
  'Debit': 4,
  'Credit': 2,
  'Cheque': 1,
  'Gift Card': 3,
}
export default {
  methods:{
    shiftsMediaTypeForKey(row, key){
      const t = paymentTypes[key]
      const arr = row.shiftsMediaTypes.filter(r=>r.MediaType === t)
      return arr.length === 0 ? {} : arr[0]
    },
    shiftsMediaTypeCountForKey(row, key){
      const t = paymentTypes[key]
      const arr = row.shiftsMediaTypesCounts.filter(r=>r.MediaType === t)
      return arr.length === 0 ? {} : arr[0]
    },
    overShort(row){
      let s,c,bt,tc,dc,dt,de;
      try{
        
        //Handle all types of non numbers
        const n = val => val === NaN || val === null || val === undefined || val === '' ? 0 : parseFloat(val)
        
        return numeral(n(row.shiftsJson.data.safe))
        .add(n(row.shiftsJson.data.coin))
        .add(n(row.shiftsJson.data.backupTerminal))

        .subtract(n(this.shiftsMediaTypeForKey(row,'Cash').MediaTotal))
        // 2104 removed both charges and thefts from cash deduction
        // .add(n(row.shiftsJson.data.deductions.charges))
        // .add(n(row.shiftsJson.data.deductions.thefts))
        .add(n(row.shiftsJson.data.deductions.errors))
        .add(n(row.shiftsJson.data.deductions.uncollected))
        .add(n(row.shiftsJson.data.deductions.pos_errors))
        .add(n(row.shiftsJson.data.deductions.pre_pay_errors))
        .value()
      }
      catch(e){
        console.log("Error with overShort", e, row)
        // console.log(s,c,bt,tc,dc,dt,de)
        return 'NA';
      }
    },
    //Quick and dirty, needs WORK
    shiftsWithTotals(location){
      let result = []
      let tmpShifts = []
      this.data[location].shifts.forEach(r=>{
        tmpShifts.push(r);

        //Not sure WHY I'm testing for id 10011
        // if(r.IDUsed === '10011'){

          const totalShift = {"StartDateTime": "", "EndDateTime": "", "IDUsed" : 'total', shiftsMediaTypes: [], shiftsMediaTypesCounts: [], "NetSalesTaxed": 0, "NetSalesNonTaxed": 0, shiftsJson:{data:{cashiers:[],deductions:{charges: 0,thefts: 0,errors: 0,},}}}
          const spacerShift = {"StartDateTime": "", "EndDateTime": "", "IDUsed" : '', shiftsMediaTypes: [], shiftsMediaTypesCounts: [], "NetSalesTaxed": 0, "NetSalesNonTaxed": 0, shiftsJson:{data:{cashiers:[],deductions:{charges: 0,thefts: 0,errors: 0,},}}}
          tmpShifts.forEach(rt=>{
              // console.log('DEBUG numeral', totalShift["NetSalesTaxed"], rt["NetSalesTaxed"])
              const addForKey = key => totalShift[key] = numeral(totalShift[key] === null ? 0 : totalShift[key]).add(rt[key] === null ? 0 : rt[key])
              
              addForKey("NetSalesTaxed")
              addForKey("NetSalesNonTaxed")
            // totalShift["NetSalesTaxed"] = numeral(totalShift["NetSalesTaxed"]).add(rt["NetSalesTaxed"])
            // totalShift["NetSalesNonTaxed"] = numeral(totalShift["NetSalesNonTaxed"]).add(rt["NetSalesNonTaxed"])
            // rt["NetSalesTaxed"] = numeral(totalShift["NetSalesTaxed"]).add(rt["NetSalesTaxed"])
            // rt["NetSalesTaxed"] = numeral(totalShift["NetSalesTaxed"]).add(rt["NetSalesTaxed"])
            // rt["NetSalesTaxed"] = numeral(totalShift["NetSalesTaxed"]).add(rt["NetSalesTaxed"])
          })
          
          result = [...result, ...tmpShifts]//, totalShift, spacerShift];
          tmpShifts = [];
        // } 
      })
      
      return result;
    },
    flattenedShiftsWithTotals(location){
      let data = this.shiftsWithTotals(location);
      let result = [];
      data.forEach(row=>{
        result.push({
          day:row.day,
          StartDateTime:row.StartDateTime,
          EndDateTime:row.EndDateTime,
          IDUsed:row.IDUsed,
          NetSalesTaxed:row.NetSalesTaxed,
          NetSalesNonTaxed:row.NetSalesNonTaxed,
          cashier:row.shiftsJson.data.cashiers[0],
          safe:row.shiftsJson.data.safe,
          coin:row.shiftsJson.data.coin,
          safeDropsCRE:row.shiftsJson.data.safeDrops ? row.shiftsJson.data.safeDrops.reduce((acc,v)=>parseFloat(acc)+parseFloat(v.creAmount),0) : 0,
          safeDropsSafe:row.shiftsJson.data.safeDrops ? row.shiftsJson.data.safeDrops.reduce((acc,v)=>parseFloat(acc)+parseFloat(v.safeAmount),0) : 0,
          bu_pos:row.shiftsJson.data.backupTerminal,
          charges:row.shiftsJson.data.deductions.charges,
          thefts:row.shiftsJson.data.deductions.thefts,
          pos_errors:row.shiftsJson.data.deductions.pos_errors,
          pre_pay_errors:row.shiftsJson.data.deductions.pre_pay_errors,
          uncollected:row.shiftsJson.data.deductions.uncollected,
          misc_errors:row.shiftsJson.data.deductions.errors,
          note:row.shiftsJson.data.note,
          os_clac:this.overShort(row),
          os_ignore:this.shiftsMediaTypeCountForKey(row,'Cash').OverShort,
          cash:this.shiftsMediaTypeCountForKey(row,'Cash').MediaTotal,
          debit:this.shiftsMediaTypeCountForKey(row,'Debit').MediaTotal,
          credit:this.shiftsMediaTypeCountForKey(row,'Credit').MediaTotal,
          cheque:this.shiftsMediaTypeCountForKey(row,'Cheque').MediaTotal,
          gift_card:this.shiftsMediaTypeCountForKey(row,'Gift Card').MediaTotal,
        })
      })

      return result;
    },
    daysWithTotals(location){
      let result = this.$math.subtotalsForKey(this.flattenedShiftsWithTotals(location), 'day')
      result.forEach(row=>{
        delete row.StartDateTime
        delete row.EndDateTime
        delete row.IDUsed
        delete row.cashier
        delete row.note
      })
      return result;
    },
    monthTotals(location){
      let result = this.$math.sumKeys(this.daysWithTotals(location))
      result.day = "Total"
      return [result]
    }
  }
}
</script>